export const activeInit = () => ({
    type: 'INIT_ACTIVE',
});
export const activeChange = (value) => ({
    type: 'ACTIVE_CHANGE',
    value
});